<inthraction-objective-distribution-summary [mode]="ObjectiveDistributionDetailsModes.HR"></inthraction-objective-distribution-summary>
